"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Button_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Button"));
var Group_1 = __importDefault(require("./Group/Group"));
var genIcon_1 = __importDefault(require("../../utils/genIcon"));
/**
 * The Button component is a clickable component for user interaction.
 * @child ./Group/Group.tsx
 */
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function () {
            var _a = _this.props, type = _a.type, className = _a.className, textTransform = _a.textTransform;
            var classes = '';
            if (type) {
                classes += type;
            }
            else {
                classes += 'primary';
            }
            if (!textTransform) {
                classes += ' no-transform';
            }
            if (className) {
                classes += ' ' + className;
            }
            return classes;
        };
        return _this;
    }
    Button.prototype.render = function () {
        var _a = this.props, content = _a.content, icon = _a.icon, children = _a.children, iconPosition = _a.iconPosition, iconRoot = _a.iconRoot, className = _a.className, minWidth = _a.minWidth, actionType = _a.actionType, type = _a.type, textTransform = _a.textTransform, cleanedProps = __rest(_a, ["content", "icon", "children", "iconPosition", "iconRoot", "className", "minWidth", "actionType", "type", "textTransform"]);
        var style = {
            minWidth: minWidth ? minWidth : 'auto'
        };
        return (React.createElement(Button_1.default, __assign({}, cleanedProps, { className: this.genClasses(), style: style, type: actionType }),
            React.createElement("div", { className: "button-content" },
                iconPosition === 'right' ? children || content : null,
                icon
                    ? genIcon_1.default(icon, {
                        root: iconRoot,
                        className: iconPosition
                    })
                    : null,
                iconPosition === 'left'
                    ? children || content
                    : null)));
    };
    Button.Group = Group_1.default;
    Button.defaultProps = {
        type: 'primary',
        size: 'medium',
        content: 'Button',
        iconRoot: 'common',
        actionType: 'button',
        iconPosition: 'left',
        loading: false,
        disabled: false,
        textTransform: true
    };
    return Button;
}(React.Component));
exports.default = Button;
